export function stripFirstCharacter(str) {
  return str.substring(1);
}

export function isDataSelector(str) {
  return str.includes('[data-');
}

export function extractDataSelector(str) {
  if (!isDataSelector(str)) {
    return str;
  }

  return str.substring(6, str.length - 1);
}

export function parseHTML(str) {
  const tmp = document.implementation.createHTMLDocument('');

  tmp.body.innerHTML = str;

  return [...tmp.body.childNodes][0];
}

export function triggerEvent(el, eventType) {
  if (typeof eventType === 'string' && typeof el[eventType] === 'function') {
    el[eventType]();
  } else {
    const event = eventType === 'string'
      ? new Event(eventType, { bubbles: true })
      : eventType;
    el.dispatchEvent(event);
  }
}

export function removeAllEvents(node) {
  const clonedNode = node.cloneNode(true);

  node.parentNode.replaceChild(clonedNode, node);
}

export function getElementParents(el, selector) {
  const parents = [];

  while ((el = el.parentNode) && el !== document) {
    if (!selector || el.matches(selector)) {
      parents.unshift(el);
    }
  }

  return parents;
}

export function getElementOffset(el) {
  const box = el.getBoundingClientRect();
  const docElem = document.documentElement;
  return {
    top: box.top + window.pageYOffset - docElem.clientTop,
    left: box.left + window.pageXOffset - docElem.clientLeft,
  };
}

export function setHeight(el, val) {
  if (typeof val === 'function') val = val();
  if (typeof val === 'string') el.style.height = val;
  else el.style.height = val + 'px';
}

// Implements :visible jQuery selector logic
/*
  Elements are considered visible if they consume space in the document. Visible elements have a width or height that is greater than zero.
  Elements with visibility: hidden or opacity: 0 are considered visible, since they still consume space in the layout.
  Elements that are not in a document are considered hidden; jQuery does not have a way to know if they will be visible when appended to a document since it depends on the applicable styles.
*/
export function isElementVisible(el) {
  // Hidden via display
  if (el.offsetParent === null) {
    return false;
  }

  // Exists in DOM check
  if (!document.body.contains(el)) {
    return false;
  }

  // Width/height check
  const rect = el.getBoundingClientRect();
  if (!rect.width && !rect.height) {
    return false;
  }

  return true;
}

const fns = {
  stripFirstCharacter,
  isDataSelector,
  extractDataSelector,
  parseHTML,
  triggerEvent,
  getElementOffset,
  getElementParents,
  setHeight,
  isElementVisible,
};

export default fns;
